module.exports = __webpack_public_path__ + "static/media/neutral_sad.b6e19e72.svg";